import styled from 'styled-components';

import { Colors } from 'modules/ui/theme/colors';

export const BoatSelect = styled.select`
  width: 100%;
  height: 40px;
  border: 1px solid ${Colors.Gray};
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 12px;
  outline: none;
  box-sizing: border-box;
  cursor: pointer;
  background: transparent;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
`;
